import diff from "../diff";
import serializePricing from "./serializePricing";
import serializeMoney from "./serializeMoney";

export default function serializeProduct(data, initialData) {
  const p = {
    ...data,

    ...serializeMoney(data.marketplace_featured_price, "marketplace_featured_price", null),
    ...serializeMoney(
      data.marketplace_featured_price_before_discount,
      "marketplace_featured_price_before_discount",
      null
    ),
    ...serializeMoney(data.saas_featured_price, "saas_featured_price", null),
    ...serializeMoney(data.saas_featured_price_before_discount, "saas_featured_price_before_discount", null),
    ...serializeMoney(data.default_saas_commision_amount, "default_saas_commision_amount", null),

    company_id: (data.company && data.company.id) || data.company_id,
    company: undefined,

    product_images_attributes:
      data.product_images && diff(data.product_images, initialData && initialData.product_images),
    product_images: undefined,

    translations_attributes: data.translations && diff(data.translations, initialData && initialData.translations),
    translations: undefined,

    product_locations_attributes:
      data.product_locations &&
      diff(
        data.product_locations.map((location) => {
          const initialLocation =
            (initialData && initialData.product_locations.find((x) => x.id === location.id)) || {};
          return {
            ...location,
            translations_attributes:
              location.translations && diff(location.translations, initialLocation && initialLocation.translations),
            translations: undefined,
          };
        }),
        initialData && initialData.product_locations
      ),
    product_locations: undefined,

    product_variants_attributes:
      data.product_variants &&
      diff(
        data.product_variants.map((variant) => {
          const initialVariant = (initialData && initialData.product_variants.find((x) => x.id === variant.id)) || {};
          return {
            ...variant,

            ...serializeMoney(
              variant.custom_pickup_point_additional_fee,
              "custom_pickup_point_additional_fee",
              "custom_pickup_point_additional_fee_currency"
            ),
            ...serializeMoney(variant.coupon_discount_amount, "coupon_discount_amount", null),
            ...serializeMoney(variant.coupon_offer_price_before_discount, "coupon_offer_price_before_discount", null),

            translations_attributes:
              variant.translations && diff(variant.translations, initialVariant && initialVariant.translations),
            translations: undefined,

            coupon_codes_attributes:
              variant.coupon_codes && diff(variant.coupon_codes, initialVariant && initialVariant.coupon_codes),
            coupon_codes: undefined,

            accommodation_detail_attributes: variant.accommodation_detail,
            accommodation_detail: undefined,

            ...serializeMoney(variant.presented_price, "presented_price", "presented_price_currency"),

            facility_product_variants_attributes:
              variant.facility_product_variants &&
              diff(variant.facility_product_variants, initialVariant && initialVariant.facility_product_variants),
            facility_product_variants: undefined,

            product_pickup_points_attributes:
              variant.product_pickup_points &&
              diff(
                variant.product_pickup_points.map((point) => {
                  const initialPoint =
                    (initialVariant && initialVariant.product_pickup_points.find((x) => x.id === point.id)) || {};
                  return {
                    ...point,
                    ...serializeMoney(point.additional_fee, "additional_fee", "additional_fee_currency"),
                    translations_attributes:
                      point.translations && diff(point.translations, initialPoint && initialPoint.translations),
                    translations: undefined,
                  };
                }),
                initialVariant && initialVariant.product_pickup_points
              ),
            product_pickup_points: undefined,

            payment_profile_product_attachments_attributes:
              variant.payment_profile_product_attachments &&
              diff(
                variant.payment_profile_product_attachments,
                initialVariant && initialVariant.payment_profile_product_attachments
              ),
            payment_profile_product_attachments: undefined,

            product_pricelist_items_attributes:
              variant.product_pricelist_items &&
              diff(
                variant.product_pricelist_items.map((item) => {
                  const initialItem =
                    (initialVariant &&
                      initialVariant.product_pricelist_items &&
                      initialVariant.product_pricelist_items.find((x) => x.id === item.id)) ||
                    {};
                  return {
                    ...item,
                    ...serializeMoney(item.price_before_discount, "price_before_discount", "price_currency"),
                    ...serializeMoney(item.price, "price", "price_currency"),

                    min_quantity: item._min_quantity,
                    max_quantity: item._max_quantity,
                    _min_quantity: undefined,
                    _max_quantity: undefined,

                    translations_attributes:
                      item.translations && diff(item.translations, initialItem && initialItem.translations),
                    translations: undefined,
                  };
                }),
                initialVariant && initialVariant.product_pricelist_items
              ),
            product_pricelist_items: undefined,
          };
        }),
        initialData && initialData.product_variants
      ),
    product_variants: undefined,

    product_order_fields_attributes:
      data.product_order_fields &&
      diff(
        data.product_order_fields.map((pof) => {
          const initialPof = (initialData && initialData.product_order_fields.find((x) => x.id === pof.id)) || {};

          const returnprice = {
            ...pof,
            price: pof.price && pof.price.value,
            price_currency: pof.price && pof.price.currency,

            price_before_discount: pof.price_before_discount && pof.price_before_discount.value,

            translations_attributes: pof.translations && diff(pof.translations, initialPof && initialPof.translations),
            translations: undefined,
            list_options_attributes:
              pof.type === "ProductOrderField::List" &&
              pof.list_options &&
              diff(
                pof.list_options.map((option) => {
                  const initialOption =
                    (initialPof &&
                      initialPof.list_options &&
                      initialPof.list_options.find((x) => x.id === option.id)) ||
                    {};
                  const _returnPrice = {
                    ...option,
                    price_before_discount: option.price_before_discount && option.price_before_discount.value,
                    price: option.price && option.price.value,
                    price_currency: option.price && option.price.currency,
                    translations_attributes:
                      option.translations && diff(option.translations, initialOption && initialOption.translations),
                    translations: undefined,
                  };
                  return _returnPrice;
                }),
                initialPof && initialPof.list_options
              ),
            list_options: undefined,
          };
          return returnprice;
        }),
        initialData && initialData.product_order_fields
      ),
    product_order_fields: undefined,
  };
  return p;
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializeProduct.js